export const formatMessageTime = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();

  const isToday = date.toDateString() === now.toDateString();

  const isThisYear = date.getFullYear() === now.getFullYear();

  // Today → 2:45 PM
  if (isToday) {
    return date.toLocaleTimeString([], {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  // This year → Jan 5, 2:45 PM
  if (isThisYear) {
    return date.toLocaleString([], {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  }

  // Older → Jan 5, 2023, 2:45 PM
  return date.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};

export const truncateString = (str, length) => {
  if (str.length <= length) {
    return str;
  }
  return str.slice(0, length);
};

export const getSlugFromPath = (url) => {
  return url.split('/').filter(Boolean).pop();
};

export const truncateStringWithEllipsis = (str, maxLength = 15) => {
  if (!str) return '';

  return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
};
